import apiService from './api.service';
import { APIKeyCreateRequest, APIKeyCreateResponse, APIKeyListResponse } from '../types/apiKey.types';

class ApiKeyService {
  async createApiKey(data: APIKeyCreateRequest): Promise<APIKeyCreateResponse> {
    const response = await apiService.client.post('/api-keys/', data);
    return response.data;
  }

  async listApiKeys(includeExpired: boolean = false): Promise<APIKeyListResponse> {
    const response = await apiService.client.get('/api-keys/', {
      params: { include_expired: includeExpired }
    });
    return response.data;
  }

  async expireApiKey(apiKeyId: string): Promise<{ message: string; success: boolean }> {
    const response = await apiService.client.delete(`/api-keys/${apiKeyId}`);
    return response.data;
  }
}

export default new ApiKeyService();